const Utils = {
    getQueryVariable:(variable) => {
        var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return decodeURI(pair[1]);}
          }
          return "";
      },

      matchSearchKeys:(dom,type='DOM',isScroll=true)=>{
        let keys = Utils.getQueryVariable('k').split(',')
        let originHtml = ''
        if(type == 'DOM'){
            originHtml = document.getElementsByClassName(dom)[0].innerHTML
        } else {
            originHtml = dom
        }
        
        let newHtml = originHtml
        
        
        keys.forEach(k=>{
            let reg = new RegExp(k,'gi');
            newHtml = newHtml.replace(reg,function(match){
                return `<font class='searchkey' color='#0083ff'>${match}</font>`;
            })
        })

        
       
        if(type == 'DOM'){
            document.getElementsByClassName(dom)[0].innerHTML = newHtml
        } else {
            return newHtml
        }
        if(isScroll){
            setTimeout(()=>{
                let top = document.getElementsByClassName('searchkey')[0]?document.getElementsByClassName('searchkey')[0].getClientRects()[0].top - 3:0
                window.scrollTo(0,top)
            })
        }
        
      },

      

}


export default Utils